import axios from "axios";

export async function fetchCalendarMatrix(companyKey, fromDate, toDate) {
    const response = await axios.get(
        `/api/productioncalendar/schedulematrix`, 
        {
            params: {
                companyKey,
                fromDate,
                toDate
            }
        }
    );
    return response.data;
}